import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import Vue from "vue";
import './assets/css/tailwind.css'
import './assets/css/MultiSelect.sass'
import './assets/css/DataTable.sass'
import './assets/css/BusinessSummary.sass'
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import store from './store/store'
import VueHighcharts from "highcharts-vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import wordcloud from "highcharts/modules/wordcloud";
import VueResource from "vue-resource";
import VuePlayerPlugin, { Player } from "vue-youtube-iframe-api";
import { VuejsDatatableFactory } from "vuejs-datatable";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Maps from "highcharts/modules/map";
import { MonthPicker } from 'vue-month-picker'



Maps(Highcharts);

library.add(faUserSecret);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.component("DateRangePicker", DateRangePicker);

Vue.use(VueResource);
Vue.use(VuePlayerPlugin);
Vue.use(MonthPicker)
Vue.component("ytb", Player);
Vue.use(VuejsDatatableFactory);

highchartsMore(Highcharts);
solidGauge(Highcharts);
wordcloud(Highcharts);
Highcharts.setOptions({
  chart: {
    backgroundColor: "transparent",
  },
});
Vue.use(VueHighcharts, { Highcharts });
Vue.use(BootstrapVue);

Vue.filter("format", function (value) {
  if (!value) return value;
  if (isNaN(value)) return value;
  value = Number(value);
  if (!Number.isInteger(value)) {
    value = value.toFixed(2);
    value = Number(value);
  }
  return value.toLocaleString();
});

// if (window.location.hostname != 'localhost')
//   console.log = function(){}
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
